import { Dispatch, SetStateAction, useState } from 'react'

import {
  AiArtworkServiceStatus,
  AiArtWorkStatus,
  AiCreateArtworkPattern,
  MemberCardRightTypeEnum,
  QueueType,
} from '~/graphqls/types'

import { ExtendsProduct } from '~/graphqls/types'
import { Popover, Tooltip } from 'antd'
import styles from './QuickTool.module.css'
import { MyIcon } from '~/components/ui/MyIcon'
import useQuickTool from '~/hooks/ai/useQuickTool'
import AIShareTitleModal from './AIShareTitleModal'
import { useHR } from '~/hooks/ai/useHR'
import SpeedCreateModal from './SpeedCreateModal'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import { observer } from 'mobx-react'
import { useStores } from '~/hooks/useStores'
import { ArtworkShareModal } from '~/components/business/ArtworkShareModal'
import { to400Image } from '~/utils'
import { useRouter } from 'next/router'
import { pattern2Header } from '~/configs/ai'
import { memberListAtom, patternAtom } from './ai-form/atom'
import { useAtom } from 'jotai'

export const QuickTool: React.FC<{
  product: ExtendsProduct
  setProduct: Dispatch<SetStateAction<ExtendsProduct>>
}> = observer(({ product: newProduct, setProduct }) => {
  const {
    handleContribute,
    handleCustom,
    handleAgain: _handleAgain,
    handleShare: _handleShare,
    handleDelete: _handleDelete,
    handleSpeedCreate: _handleSpeedCreate,
    handleCancelCreate: _handleCancelCreate,
    DownloadDropdown,
    hiddenDownloadDropdown,
    handleDownload,
    handlePlazaPublish,
    handlePlazaRefresh,
  } = useQuickTool(newProduct)

  const [memberList] = useAtom(memberListAtom)
  const [pattern] = useAtom(patternAtom)

  const router = useRouter()
  const { store } = useStores()

  {
    /* 再来一张 */
  }
  const handleAgain = () => {
    _handleAgain()
    store.ai?.setIsAgain(true)
  }
  {
    /* 分享 */
  }
  const [shareVisible, setShareVisible] = useState(false)
  const [shareTitleVisible, setShareTitleVisible] = useState(false)
  const [shareTitle, setShareTitle] = useState('')
  const [shareVisibleInitImage, setShareVisibleInitImage] = useState(false)
  const handleShare = async () => {
    _handleShare(() => {
      setShareTitleVisible(true)
    })
  }

  {
    /* 超分辨 */
  }
  /** 权益卡可用超分辨次数 */
  let supersizeTimes = 0
  memberList.forEach(item => {
    item.holdCardInfo?.forEach(i => {
      if (i?.rightType === MemberCardRightTypeEnum.SUPER_RESOLUTION) {
        supersizeTimes += i!.num || 0
      }
    })
  })
  const {
    hrOpen,
    setHrOpen,
    previewVisible,
    setPreviewVisible,
    previewImage,
    updateSuperSizeInfo: _updateSuperSizeInfo,
    handleSuperSize: _handleSuperSize,
    validateSuperSize: _validateSuperSize,
    HRDropdown: _HRDropdown,
  } = useHR({
    product: newProduct,
    setProduct,
    supersizeTimes,
  })

  const handleSuperSize = (multiple: number, points: number = 0) => {
    _handleSuperSize(multiple, points)?.then(() => {
      store.ai?.setIsRefreshMemberList(true)
      store.ai?.setIsRefreshTotalInfo(true)
      _updateSuperSizeInfo()
    })
  }

  {
    /* 删除 */
  }
  const handleDelete = async () => {
    _handleDelete(() => {
      store.ai?.setIsRefeshPreviewData(true)
    })
  }

  {
    /* 加速生成 */
  }
  const [speedVisible, setSpeedVisible] = useState(false)
  const speedCreate = async ({
    points,
    vipTimes,
  }: {
    points: number
    vipTimes: number
  }) => {
    _handleSpeedCreate({
      points,
      vipTimes,
    })?.finally(() => {
      setSpeedVisible(false)
    })
  }

  {
    /* 撤销 */
  }
  const cancelCreate = () => {
    _handleCancelCreate(() => {
      store.ai?.setIsRefeshPreviewData(true)
    })
  }

  const inviteCode = store?.userinfo?.inviteCode || ''
  const path = pattern2Header[pattern as keyof typeof pattern2Header].link
  const qrUrl = `${process.env.NEXT_PUBLIC_MOBILE_SITE}${path}?inviteCode=${inviteCode}`
  const copyUrl = `${process.env.NEXT_PUBLIC_SITE}/ai/share/${newProduct.id}?inviteCode=${inviteCode}&uid=${store.userinfo?.base?.uid}`

  const isCleaned = newProduct.serviceStatus === AiArtworkServiceStatus.CLEANED

  return (
    <div>
      <div className="flex flex-col">
        {/* 再来一张 */}
        <Tooltip
          placement="left"
          title="再来一张"
          zIndex={998}
          overlayClassName={styles.tooltip}
          mouseLeaveDelay={0}
        >
          <div className={styles.btn} onClick={handleAgain}>
            <MyIcon
              icon="again"
              className="text-neutral-400 text-[24px] icon"
            />
          </div>
        </Tooltip>

        {[AiArtWorkStatus.SUCCESS].includes(newProduct?.status!) &&
          !isCleaned && (
            <>
              {/* 下载 */}
              {!hiddenDownloadDropdown ? (
                <Popover
                  content={DownloadDropdown}
                  placement="left"
                  trigger={'click'}
                  color="#23262F"
                  overlayClassName={styles.popover}
                  zIndex={999}
                >
                  <Tooltip
                    placement="left"
                    title="下载"
                    zIndex={998}
                    overlayClassName={styles.tooltip}
                    mouseLeaveDelay={0}
                  >
                    <div className={styles.btn}>
                      <MyIcon
                        icon="file-download"
                        className="text-neutral-400 text-[24px] icon"
                      />
                    </div>
                  </Tooltip>
                </Popover>
              ) : (
                <Tooltip
                  placement="left"
                  title="下载"
                  zIndex={998}
                  overlayClassName={styles.tooltip}
                  mouseLeaveDelay={0}
                >
                  <div className={styles.btn} onClick={() => handleDownload()}>
                    <MyIcon
                      icon="file-download"
                      className="text-neutral-400 text-[24px] icon"
                    />
                  </div>
                </Tooltip>
              )}

              {/* 投稿 */}
              <Tooltip
                placement="left"
                title="投稿"
                zIndex={998}
                overlayClassName={styles.tooltip}
                mouseLeaveDelay={0}
              >
                <div className={styles.btn} onClick={handleContribute}>
                  <MyIcon
                    icon="cup"
                    className="text-neutral-400 text-[24px] icon"
                  />
                </div>
              </Tooltip>

              {/* 分享 */}
              <Tooltip
                placement="left"
                title="分享"
                zIndex={998}
                overlayClassName={styles.tooltip}
                mouseLeaveDelay={0}
              >
                <div className={styles.btn} onClick={handleShare}>
                  <MyIcon
                    icon="sharesquare"
                    className="text-neutral-400  text-[24px] icon"
                  />
                </div>
              </Tooltip>
              {shareTitleVisible && (
                <AIShareTitleModal
                  visible={shareTitleVisible}
                  setVisible={setShareTitleVisible}
                  showInitImage={!!newProduct?.initImageUrl}
                  onSuccess={({ shareTitle, visibleInitImage }) => {
                    setShareTitle(shareTitle.trim())
                    setShareVisibleInitImage(visibleInitImage)
                    setShareTitleVisible(false)
                    setShareVisible(true)
                  }}
                />
              )}
              {shareVisible && (
                <ArtworkShareModal
                  dark={true}
                  visible={shareVisible}
                  setVisible={setShareVisible}
                  options={{
                    type: 'ai',
                    author: newProduct.userName!,
                    id: newProduct?.id!,
                    title: shareTitle!,
                    imgUrl: to400Image(newProduct.miniArtWorkUrl!),
                    link: qrUrl,
                    copyUrl: copyUrl,
                    initImageUrl:
                      shareVisibleInitImage && newProduct?.initImageUrl
                        ? newProduct?.initImageUrl
                        : '',
                  }}
                />
              )}

              {/* 超分辨 */}
              <Popover
                content={_HRDropdown(handleSuperSize)}
                placement="left"
                trigger={'click'}
                color="#23262F"
                overlayClassName={styles.popover}
                zIndex={999}
                onOpenChange={setHrOpen}
                open={hrOpen}
              >
                <Tooltip
                  placement="left"
                  title="超分辨"
                  zIndex={998}
                  overlayClassName={styles.tooltip}
                  mouseLeaveDelay={0}
                >
                  <div className={styles.btn} onClick={_validateSuperSize}>
                    <MyIcon
                      icon="scale"
                      className="text-neutral-400 text-[24px] icon"
                    />
                  </div>
                </Tooltip>
              </Popover>
              {/*涂抹/黄图不能发布*/}
              {!newProduct.extend?.squarePostLink &&
                !!newProduct.extend?.similarAiArtworkPost?.id &&
                !newProduct.maskImageUrl &&
                !newProduct.involveYellow && (
                  <Tooltip
                    placement="left"
                    title="更新到词/图"
                    zIndex={998}
                    overlayClassName={styles.tooltip}
                    mouseLeaveDelay={0}
                  >
                    <div
                      className={styles.btn}
                      onClick={() =>
                        handlePlazaRefresh(
                          newProduct.extend?.similarAiArtworkPost?.id,
                          () => {
                            router.push(
                              `/plaza/${newProduct.extend?.similarAiArtworkPost?.id}`
                            )
                          }
                        )
                      }
                    >
                      <MyIcon
                        icon="publish"
                        className="text-neutral-400  text-[24px] icon"
                      />
                    </div>
                  </Tooltip>
                )}
              {pattern !== AiCreateArtworkPattern.MASK &&
                !newProduct.extend?.squarePostLink &&
                !newProduct.extend?.similarAiArtworkPost?.id &&
                !newProduct.maskImageUrl &&
                !newProduct.involveYellow && (
                  <Tooltip
                    placement="left"
                    title="发布词/图"
                    zIndex={998}
                    overlayClassName={styles.tooltip}
                    mouseLeaveDelay={0}
                  >
                    <div className={styles.btn} onClick={handlePlazaPublish}>
                      <MyIcon
                        icon="publish"
                        className="text-neutral-400  text-[24px] icon"
                      />
                    </div>
                  </Tooltip>
                )}
              <Lightbox
                open={previewVisible}
                close={() => setPreviewVisible(false)}
                index={0}
                slides={[{ src: previewImage }]}
                render={{
                  buttonPrev: () => null,
                  buttonNext: () => null,
                }}
                carousel={{
                  finite: true,
                  preload: 2,
                  imageFit: 'contain',
                }}
                animation={{ fade: 250, swipe: 500 }}
              />

              {/* 定制商品 */}
              <Tooltip
                placement="left"
                title="定制商品"
                zIndex={998}
                overlayClassName={styles.tooltip}
                mouseLeaveDelay={0}
              >
                <div className={styles.btn} onClick={handleCustom}>
                  <MyIcon
                    icon="gift"
                    className="text-neutral-400 text-[24px] icon"
                  />
                </div>
              </Tooltip>
            </>
          )}

        {/* 删除 */}
        {[AiArtWorkStatus.SUCCESS, AiArtWorkStatus.FAIL].includes(
          newProduct?.status!
        ) && (
          <Tooltip
            placement="left"
            title="删除"
            zIndex={998}
            overlayClassName={styles.tooltip}
            mouseLeaveDelay={0}
          >
            <div className={styles.btn} onClick={handleDelete}>
              <MyIcon
                icon="trash"
                className="text-neutral-400 text-[24px] icon"
              />
            </div>
          </Tooltip>
        )}

        {![
          AiArtWorkStatus.SUCCESS,
          AiArtWorkStatus.CANCEL,
          AiArtWorkStatus.FAIL,
        ].includes(newProduct?.status!) &&
          newProduct.queueType !== QueueType.NIGHT && (
            <>
              {/* 加速生成 */}
              <Tooltip
                placement="left"
                title="加速生成"
                zIndex={998}
                overlayClassName={styles.tooltip}
                mouseLeaveDelay={0}
              >
                <div
                  className={styles.btn}
                  onClick={() => {
                    setSpeedVisible(true)
                  }}
                >
                  <MyIcon
                    icon="integral"
                    className="text-neutral-400 text-[24px] icon"
                  />
                </div>
              </Tooltip>
              {speedVisible && (
                <SpeedCreateModal
                  queueInfo={{
                    queue: newProduct?.queueBeforeNum || 0,
                    expectedSeconds: newProduct?.expectedSeconds || 0,
                    reduceTime: newProduct?.reduceTime || 0,
                  }}
                  visible={speedVisible}
                  close={() => {
                    setSpeedVisible(false)
                  }}
                  buyFn={speedCreate}
                />
              )}

              {/* 撤销 */}
              <Tooltip
                placement="left"
                title="撤销"
                zIndex={998}
                overlayClassName={styles.tooltip}
                mouseLeaveDelay={0}
              >
                <div className={styles.btn} onClick={cancelCreate}>
                  <MyIcon
                    icon="cancel"
                    className="text-neutral-400 text-[24px] icon"
                  />
                </div>
              </Tooltip>
            </>
          )}
      </div>
    </div>
  )
})
